const DocumentationPage = () => {
  return <div>Documentation</div>;
};

export default DocumentationPage;
